import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { stringToPointNumber } from "MainPages/Utils/decimal.utils";
import { formatDate } from "core/Operations/dateFormat";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const VehicleAccidentModal = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  const handleModalSubmit = (e) => {
    e.stopPropagation();
  };

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>
            {mode === "I" ? "Add Vehicle Accident" : "Edit Vehicle Accident"}
          </h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit={(e) => {
            handleModalSubmit(e);
            handleSubmit(onSubmit)(e);
          }}
          className="needs-validation"
        >
          <div className="form-row row">
            <div className="col-md-6 mb-3">
              <Input
                name="driverName"
                label="Driver Name"
                labelClassName="form-label"
                placeholder="Enter Driver Name"
                type="text"
                className={`form-control ${
                  errors.driverName ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Driver Name is required"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="accidentDate"
                label="Accident Date"
                labelClassName="form-label"
                placeholder="Enter Accident Date"
                type="date"
                onChange={(date) => {
                  setValue(
                    "accidentDate",
                    date ? dayjs(date).format("YYYY-MM-DD") : ""
                  );
                  trigger("accidentDate");
                }}
                className={`form-control ${
                  errors.accidentDate ? "is-invalid" : ""
                }`}
                dateFormat="YYYY-MM-DD"
                defaultValue={
                  dayjs(watch("accidentDate"), "YYYY-MM-DD") || null
                }
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                required
                requiredMessage="Accident Date is required"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="accidentLocation"
                label="Accident Location"
                placeholder="Enter Accident Location"
                type="string"
                className={`form-control ${
                  errors.accidentLocation ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Accident Location is required"
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="driverContactNumber"
                label="Driver Contact Number"
                placeholder="Enter Driver Contact Number"
                type="number"
                className={`form-control ${
                  errors.driverContactNumber ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Driver Contact Number is required"
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="refundFromInsuranceAmount"
                label="Refund From Insurance Amount"
                placeholder="Enter Refund From Insurance Amount"
                type="number"
                className={`form-control ${
                  errors.refundFromInsuranceAmount ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Refund From Insurance Amount is required"
                onChange={(e) => stringToPointNumber(e.target.value)}
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="actualRepairingAmount"
                label="Actual Repairing Amount"
                placeholder="Enter Actual Repairing Amount"
                type="number"
                className={`form-control ${
                  errors.actualRepairingAmount ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Actual Repairing Amount is required"
                labelClassName="form-label"
                onChange={(e) => stringToPointNumber(e.target.value)}
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="vehicleNumber"
                label="Vehicle Number"
                labelClassName="form-label"
                placeholder="Enter Vehicle Number"
                type="string"
                className={`form-control ${
                  errors.vehicleNumber ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Vehicle Number is required"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="isActive"
                type="commonSelect"
                placeholder="Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Status"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Status is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("isActive", selectedOption);
                  trigger("isActive");
                }}
                defaultValue={watch("isActive")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>
          </div>

          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

VehicleAccidentModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default VehicleAccidentModal;
